module.exports = __webpack_public_path__ + "static/img/10commitments_1.8220366.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/10commitments_1.jpg
// module id = udaK
// module chunks = 0